export default __webpack_public_path__ + "whatsappIcon.cc5de5cf.png";